import { useEffect, useMemo, useState } from 'react';
import dayjs from 'dayjs';
import { useTransactionsStore } from '@lib/store';
import { AmountUtils } from '@shared/utils';
import type { GetTransactionsResponse } from '@shared/api';
import { PrintInfoModal } from './printInfoModal';
import { Table } from '@shared/widgets';
import EllipsisIcon from '@assets/icons/ellipsis.svg';

export const PaymentsOverview = () => {
  const { loading, data, getTransactions } = useTransactionsStore();

  const [isVisibleModal, setIsVisibleModal] = useState<boolean>(false);
  const [selectedTransaction, setSelectedTransactions] = useState<GetTransactionsResponse | undefined>();

  const [sortOrder, setSortOrder] = useState<string>('desc');

  useEffect(() => {
    getTransactions('c10b71ee-0f03-e711-80c4-00155d5bc507');
  }, []);

  const COLUMNS = [
    { title: 'Registration Date', onSort: () => setSortOrder((prev) => (prev === 'asc' ? 'desc' : 'asc')) },
    { title: 'DESCRIPTION' },
    { title: 'TO/FROM' },
    { title: 'Amount' },
    { title: 'STATUS' },
    { title: 'i' },
  ];
  const sortedData = useMemo(() => {
    const sorted = [...data];
    if (sortOrder === 'asc') sorted.sort((a, b) => (dayjs(a.Date).isBefore(dayjs(b.Date)) ? -1 : 1));
    else if (sortOrder === 'desc') sorted.sort((a, b) => (dayjs(a.Date).isBefore(dayjs(b.Date)) ? 1 : -1));
    return sorted;
  }, [data, sortOrder]);
  return (
    <>
      <Table
        className='mt-6.5'
        isScrollable
        loading={loading}
        columns={COLUMNS}
        items={sortedData.map((row) => {
          return [
            { value: row.Date ? dayjs(row.Date).format('DD.MM.YYYY') : '--' },
            { value: row.Description ? row.Description : '--' },
            { value: row.Beneficiary ? row.Beneficiary : '--' },
            { value: row.PaidOut ? `${row.Currency || ''} ${AmountUtils.transformToAmount(row.PaidOut)}` : '--' },
            { value: row.Status ? <div className={`${row.Status === 'Rejected' ? 'text-[#e42d34]' : ''}`}>{row.Status}</div> : '--' },
            {
              value: (
                <EllipsisIcon className='cursor-pointer fill-[#b9b9b9]' onClick={() => (setSelectedTransactions(row), setIsVisibleModal(true))} />
              ),
              more: true,
            },
          ];
        })}
        sortOrder={sortOrder}
      />
      <PrintInfoModal isOpen={isVisibleModal} onClose={() => setIsVisibleModal(false)} transaction={selectedTransaction} />
    </>
  );
};
